import { Field, JsonParseError, JsonParseErrorCode } from "sparkson";

export class VisibilityRange {
  startTime: number;
  endTime: number | "END";

  constructor(@Field("s") startOffset: string, @Field("e") endOffset: string) {
    this.startTime = Number(startOffset) / 1000;

    if (isNaN(this.startTime)) {
      throw new JsonParseError("startOffset must be a string that can be parsed as number", JsonParseErrorCode.VALIDATION_FAILED);
    }

    if (endOffset === "END") {
      this.endTime = "END";
    } else {
      this.endTime = Number(endOffset) / 1000;
      if (isNaN(this.endTime)) {
        throw new JsonParseError(
          "endOffset must be either string 'END' or a string that can be parsed as number",
          JsonParseErrorCode.VALIDATION_FAILED,
        );
      }
    }
  }
}
